// extracted by mini-css-extract-plugin
export var highlightFade = "_24-4";
export var highlighted = "_24-3";
export var table = "_24-1";
export var tableContainer = "_24-0";
export var totalsRow = "_24-2";